export enum PaymentStatus {
  Paid = 'paid',
  // PaidAfterDuedate = 'paidAfterDuedate', This should be part of specifc payment logic
  // Overdue = 'overdue',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Refunded = 'refunded',
  Failed = 'failed',
}

export enum CustomerPaymentStatus {
  Paid = 'paid',
  PaidAfterDuedate = 'paidAfterDuedate',
  Overdue = 'overdue',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Refunded = 'refunded',
  Failed = 'failed',
}

export enum PaymentProvider {
  Stripe = 'stripe',
  PayPal = 'paypal',
  Manual = 'manual',
}
